import React, { useState } from 'react';
import '../CSS/flipCard.css';

interface FlipCardProps {
  imageUrl?: string;
  title: string;
  description: string;
  onClick?: () => void;
}

const FlipCard: React.FC<FlipCardProps> = ({
  imageUrl,
  title,
  description,
  onClick
}) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = (e: React.MouseEvent) => {
    // Don't flip if clicking the button
    if ((e.target as HTMLElement).closest('.flip-card-button')) return;
    
    // Only handle click events on mobile devices
    if (window.matchMedia('(max-width: 768px)').matches) {
      setIsFlipped(!isFlipped);
    }
  };

  return (
    <div className={`flip-card ${isFlipped ? 'is-flipped' : ''}`} onClick={handleCardClick}>
      <div className="flip-card-front">
        <img src={imageUrl || '/placeholder-image.jpg'} alt={title} />
      </div>
      <div className="flip-card-back">
        <h3>{title}</h3>
        {onClick && (
          <button className="flip-card-button" onClick={onClick}>
            View Details
          </button>
        )}
      </div>
    </div>
  );
};

export default FlipCard;
